"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTripReference = void 0;
const class_validator_1 = require("class-validator");
/**
 * Validates that a string is a supported trip reference.
 */
function IsTripReference(validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "isTripReference",
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: {
                validate(value) {
                    return (typeof value === "string" && // trip reference is a string
                        (value.length === 6 || value.length === 25) && // either 6 or 25 characters long
                        /^[a-fA-F0-9]{6}|[a-z0-9]{25}$/.test(value) // either derived from order or ride identifier, or it is pool trip id
                    );
                },
            },
        });
    };
}
exports.IsTripReference = IsTripReference;
//# sourceMappingURL=IsTripReference.js.map